import dayjs, { unix } from 'dayjs'

import { usePreferencesStore, PreferenceKey } from '@/entities/preference'

import { resolveTimezone } from '@/shared/lib/resolve-timezone'

const TIMEZONE_LOCALSTORAGE_KEY = 'timezone'

const readStoredTimezone = (): string | undefined => {
  const { preferences } = usePreferencesStore()
  const timezonePreference = preferences?.[PreferenceKey.CURRENT_TIME_ZONE] as string | undefined
  const timezoneFromLS = window.localStorage.getItem(TIMEZONE_LOCALSTORAGE_KEY) ?? undefined

  return timezonePreference ?? timezoneFromLS
}

export const getProfileTimezone = (): string => {
  const storedTimezone = readStoredTimezone()
  if (storedTimezone) {
    return resolveTimezone(storedTimezone)
  }

  return resolveTimezone(dayjs.tz.guess())
}

export const getDayJSInTimezone = (value: number) => {
  return unix(value).tz(getProfileTimezone())
}
